<template>
<div>
  <!-- remove modal -->
  <va-modal
    v-model="dialog"
    title="Atenção"
    :message="`Deseja realmente exlcuir o cliente: ${this.temp_client.name}`"  
    hideDefaultActions
  >

    <va-button
      color="primary"
      class="ma-0"
      @click="dialog = false">
      Cancelar
    </va-button>

    <va-button
      color="secondary"
      class="ml-2 right"
      @click="remove()">
      Sim eu tenho certeza!
    </va-button>
  </va-modal>

  <va-card :title="$t('menu.clients')">
    <div class="flex xs12 sm3">
      <va-button
        medium
        inline
        color="secondary"
        icon="fa fa-plus"
        class="ma-0"
        @click="$router.push({name: 'client-form'})">
        {{ $t('menu.new') }}
      </va-button>

      <va-button v-if="ability.can('import', 'Clients')"
        medium
        inline
        color="secondary"
        icon="fa fa-cloud-upload"
        class="ma-0"
        to="/admin/tables/import-client"
      >
        {{ $t('menu.import') }}
      </va-button>
    </div>
    
    <va-data-table
      :fields="fields"
      :data="clients"
      :per-page="5"
      :total-pages="10"
      api-mode
      no-pagination
      no-data-label="Nothing to display, sir!">
     
      <template slot="actions" slot-scope="item">
        <!-- edit -->
        <va-button
          small
          inline
          color="green"
          icon="fa fa-edit"
          class="ma-0"
          :to="{ name: 'client-form', params: { id: item.rowData.id } }">
          {{ $t('menu.edit') }}
        </va-button>

        <!-- delete -->
        <va-button
          small
          inline
          color="danger"
          icon="fa fa-remove"
          class="ma-0 ml-2"
          @click="confirmRemove(item.rowData)">
          {{ $t('tables.delete') }}
        </va-button>
      </template>
    </va-data-table>
  </va-card>
</div>
</template>

<script>
import { http } from "@/services/config";
import { showError } from '@/global'
import { mapState } from "vuex";
import definedAbilitiesFor from '@/config/ability';

export default {
  data() {
    return {
      dialog: false,
      temp_client: '',
      clients: [],
      ability: [],
      fields: [
        { name: "id", title: "ID" },
        { name: "name", title: "Nome" },
        { name: "trading_name", title: "Nome Comercial" },
        { name: "address", title: "Endereço" },
        { name: "district", title: "Bairro" },
        { name: "city", title: "Cidade" },
        { name: "state", title: "Estado" },
        { name: "zip_code", title: "CEP" },
        { name: "latitude", title: "Latitude" },
        { name: "longitude", title: "Longitude" },
        { name: '__slot:actions', dataClass: 'text-right' }
      ]
    }
  },

  beforeMount(){
    this.ability = definedAbilitiesFor(this.currentUser)
  },

  mounted(){
    this.getClients()
  },

  computed: {
    ...mapState(["currentUser"]),
  },

  methods: {
    getClients(){
      http.get("/clients").then(response => {
        this.clients = response.data["clients"]
      }).catch(e => {
        showError(e)
      })
    },

    confirmRemove(item) {
      this.dialog = true;
      this.temp_client = { ...item };
    },

    remove() {
      this.dialog = false;
      http.delete(`/clients/${this.temp_client.id}`).then(() => {
        this.$toasted.global.defaultSuccess();
        this.getClients();
      }).catch(e => showError(e));
    },
  }

}
</script>